import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './Header.css';

interface HeaderProps {
  toggleMenu: () => void;
  onReserveClick: () => void;
  onLoginClick: () => void; // <--- Añadida para el modal de sesión
}

const Header: React.FC<HeaderProps> = ({ toggleMenu, onReserveClick, onLoginClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      {/* Pasamos ambas funciones hacia abajo al Navbar */}
      <Navbar
        toggleMenu={toggleMenu}
        isScrolled={isScrolled}
        onReserveClick={onReserveClick}
        onLoginClick={onLoginClick} // <--- Prop conectada
      />
    </header>
  );
};

export default Header;